import { Component, ViewChild, NgZone, OnInit } from '@angular/core';
import { AppConfig } from '../../../app-config';
import { Location } from '@angular/common';
import { PortalStorageService } from '@app/core/services';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
})
export class AdminComponent implements OnInit {
    public appConfig: any;
    public navCollapsed: boolean;
    public navCollapsedMob: boolean;
    public windowWidth: number;
    @ViewChild('nav') nav: any;
    @ViewChild('mainwrapper') mainWrapper: any;

    constructor(private zone: NgZone, private location: Location, private storageService: PortalStorageService) {
        const theme = this.storageService.getTheme();
        if (theme !== undefined && theme !== null) {
            AppConfig.config.layoutType = theme;
        }

        const hideNav = this.storageService.getNav();
        if (hideNav !== undefined && hideNav !== null) {
            AppConfig.config.collapseNav = JSON.parse(hideNav);
        }

        this.appConfig = AppConfig.config;

        let current_url = this.location.path();
        if (this.location['_baseHref']) {
            current_url = this.location['_baseHref'] + this.location.path();
        }

        if (current_url === this.location['_baseHref'] + '/layout/collapseMenu' || current_url === this.location['_baseHref'] + '/layout/box') {
            this.appConfig['collapseMenu'] = true;
        }

        this.windowWidth = window.innerWidth;
        this.navCollapsed = this.windowWidth >= 992 ? this.appConfig['collapseMenu'] : false;
        this.navCollapsedMob = false;
    }

    ngOnInit(): void {
        // const eNav: HTMLElement = document.querySelector('.pcoded-navbar');
        // // const eNavForsite: HTMLElement = document.querySelector('#nav-ps-forsite');
        // if (this.windowWidth < 992) {
        //     this.appConfig.layout = 'vertical';
        //     setTimeout(() => {
        //         eNav.classList.add('menupos-static');
        //         // eNavForsite.style.maxHeight = '100%'; // 100% amit
        //     }, 500);
        // }
    }

    navMobClick(): void {
        if (this.navCollapsedMob && !document.querySelector('app-navigation.pcoded-navbar').classList.contains('mob-open')) {
            this.navCollapsedMob = !this.navCollapsedMob;
            setTimeout(() => {
                this.navCollapsedMob = !this.navCollapsedMob;
            }, 100);
        } else {
            this.navCollapsedMob = !this.navCollapsedMob;
        }
    }
}
